export enum ContractCostTypeEnum {
	Fixed = 0,
	Variable = 10
}
